import React,{useEffect} from "react";
import {useLocation} from "react-router-dom";
import {toast} from "react-toastify";
import routes from "./routes";
import useJumboRoutes from "@jumbo/hooks/useJumboRoutes";

const AppRoutes = () => {
    const appRoutes = useJumboRoutes(routes);

    const location = useLocation();

    useEffect(()=>{
        if (!(location.pathname.includes("/docgen/drafts") ||  location.pathname.includes("/docgen/matters"))) {
            toast.dismiss();
        }
    },[location])

    return (
        <React.Fragment>
            {
                appRoutes
            }
        </React.Fragment>
    );
};
export default AppRoutes;
